import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConfirmAddress from './ConfirmAddress';
import loading from '../../../../actions/loading';
import loaded from '../../../../actions/loaded';

const mapStateToProps = ({ estimateBuilder }) => {
  const { validationResult } = estimateBuilder.mandiAvailability;
  return { ...validationResult };
};

const mapDispatchToProps = dispatch => bindActionCreators({ loading, loaded }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAddress);
